// ANCHOR React
import React, { memo } from 'react';

// ANCHOR Img
import { Img } from '@lyon/components/image';

export const LyonRestrictedImage = memo(() => (
  <Img
    src="/restricted.svg"
    alt="Restricted"
  />
));
